import {
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  Box,
  Text,
} from '@frontend/components';

const AwsCredentialsWarning = () => (
  <Alert status="warning">
    <AlertIcon />
    <Box>
      <AlertTitle>Ensure credentials are correct</AlertTitle>
      <AlertDescription>
        <Text>
          These credentials will not be validated until the customer sets up
          this integration on the Cloud Connector.
        </Text>
        <Text>
          If you enter incorrect credentials, the customer will not be able to
          set up their integration.
        </Text>
      </AlertDescription>
    </Box>
  </Alert>
);

export default AwsCredentialsWarning;
